import Enum from '@/apis/enum'

export function reportStatus (val) {
  return Enum.getLabel(val, Enum.BRIEF_STATUS)
}

export function reportAttribute (val) {
  return Enum.getLabel(val, Enum.BRIEF_ATTRIBUTE)
}

export function status (val) {
  return Enum.getLabel(val, Enum.STATUS)
}

export function source (val) {
  return Enum.getLabel(val, Enum.SOURCE)
}

export function authority (val) {
  return Enum.getLabel(val, Enum.AUTHORITY)
}

export function videoType (val) {
  return Enum.getLabel(val, Enum.VIDEO_TYPE)
}

export function internalMemo (isHaveMemo) {
  if (isHaveMemo) {
    return 'primary'
  } else {
    return 'info'
  }
}

export function whether (val) {
  if (val) {
    return '是'
  } else {
    return '否'
  }
}

export function getClass (_class) {
  return Enum.MEMO_CLASS[_class].label
}
